/**
 * Fee Types
 */
export enum FeeType {
  MealPeriodViolation = 'Meal Period Violation',
  LatePayDamagesPerDayLT25 = 'Up to 25 Days (Per Day)',
  LatePayDamagesMaximum = 'Maximum',
  LatePayDamagesOnNonPaymentNotice = 'On Non-Nayment Notice',
  LatePayDamagesPerDayAfterNonPaymentNoticeGTE25 = 'Each Day After Non-Payment Notice ≧ 25 days',
}

/**
 * Estimate Fee Types
 */
export enum EstimateFeeType {
  WardrobeFee = 'Wardrobe Fee',
  WardrobeFeeEveningWear = 'Wardrobe - Fee Evening Wear',
  WardrobeFeePeriodWear = 'Wardrobe - Fee PeriodWear',
  StudioZoneTravelFee = 'Studio Zone Travel Fee',
  AuditionScratchTrackFee = 'Audition Scratch Track Fee',
  LineMemorizationFee = 'Line Memorization Fee',
  DancersHazardFee1stDay = 'Dancers Hazard Fee - 1st Day',
  DancersHazardFeeAdditionalDays = 'Dancers Hazard Fee - Additional Days',
  DancersFootwearFee = 'Dancers Footwear Fee',
  StuntAdjustmentFee = 'Stunt Adjustment Fee',
  FlightInsuranceFee = 'Flight Insurance Fee',
  GroupContractorFee = 'Group Contractor Fee',
  GroupContractorFee3To5 = 'Group Contractor Fee - 3 To 5',
  GroupContractorFee6To8 = 'Group Contractor Fee - 6 To 8',
  GroupContractorFee9Plus = 'Group Contractor Fee - 9 Plus',
  PilotSessionFeeStudio = 'Pilot Session Fee - Studio',
  PilotSessionFeeOnLocation = 'Pilot Session Fee - On Location',
  WetSnowSmokeDustWorkAllowance = 'Wet/Snow/Smoke/Dust Work Allowance',
}
